import React, { useEffect } from 'react'
import NavHeader from '../Components/NavHeader'
import Footer from '../Components/Footer'
import Cards from '../Components/Portafolio/Cards'
import data from '../Components/json/data'


const setMeta = (name, content, attr = 'name') => {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const Portafolio = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const prevTitle = document.title;
    document.title = 'Portafolio | Dscode - Landing pages, Ecommerce y Sistemas';
    setMeta(
      'description',
      'Conocé el portafolio de Dscode: landing pages, tiendas online (ecommerce) y sistemas a medida desarrollados para empresas en Paraguay y la región.'
    );
    setCanonical('https://dscode.com.py/portafolio');
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <>
      <NavHeader />
      <section id='portafolio' className='ds-section min-vh-100'>
        <div className="ds-section-bg"></div>
        <div className='container pt-5 pb-5 position-relative'>
          <div className='text-white text-center pt-5 mb-5'>
            <span className="ds-eyebrow">Nuestro trabajo</span>
            <h1 className='ds-titulo mt-2 mb-3'>Portafolio</h1>
            <p className='ds-lead mb-0'>
              Landing pages, ecommerces y sistemas desarrollados por Dscode.
            </p>
          </div>

          <div className="port-grid">
            {data.map((card, index) => (
              <Cards
                key={index}
                title={card.title}
                imgSrc={card.imgSrc}
                link={card.link}
                tipo={card.tipo}
                descripcion={card.descripcion}
              />
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default Portafolio
